import { DEFAULT_PERMISSIONS, type User } from '@/types/user';

export const mockUsers: User[] = [
  {
    id: '1',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@company.com',
    phone: '+44 20 7946 0001',
    role: 'administrator',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    companies: ['1', '2', '3'],
    companyCount: 3,
    permissions: DEFAULT_PERMISSIONS.administrator,
    lastLogin: '2024-01-15T10:30:00Z',
    createdAt: '2023-01-10T08:00:00Z',
  },
  {
    id: '2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@company.com',
    phone: '+44 20 7946 0002',
    role: 'user',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    companies: ['1', '2'],
    companyCount: 2,
    permissions: DEFAULT_PERMISSIONS.user,
    lastLogin: '2024-01-15T09:15:00Z',
    createdAt: '2023-03-15T10:00:00Z',
  },
  {
    id: '3',
    firstName: 'Michael',
    lastName: 'Chen',
    email: 'michael.chen@company.com',
    phone: '+44 121 496 0003',
    role: 'user',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    companies: ['2', '3', '4'],
    companyCount: 3,
    permissions: DEFAULT_PERMISSIONS.user,
    lastLogin: '2024-01-14T16:45:00Z',
    createdAt: '2023-05-20T14:30:00Z',
  },
  {
    id: '4',
    firstName: 'Emily',
    lastName: 'Rodriguez',
    email: 'emily.rodriguez@company.com',
    role: 'user',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
    companies: ['1'],
    companyCount: 1,
    permissions: DEFAULT_PERMISSIONS.user,
    lastLogin: '2024-01-15T08:00:00Z',
    createdAt: '2023-07-01T09:00:00Z',
  },
  {
    id: '5',
    firstName: 'David',
    lastName: 'Williams',
    email: 'david.williams@company.com',
    phone: '+44 161 850 0004',
    role: 'administrator',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    companies: ['1', '2', '3', '4', '5'],
    companyCount: 5,
    permissions: DEFAULT_PERMISSIONS.administrator,
    lastLogin: '2024-01-13T14:20:00Z',
    createdAt: '2023-02-05T11:00:00Z',
  },
  {
    id: '6',
    firstName: 'Lisa',
    lastName: 'Anderson',
    email: 'lisa.anderson@company.com',
    phone: '+44 113 496 0005',
    role: 'user',
    status: 'inactive',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
    companies: ['3'],
    companyCount: 1,
    permissions: DEFAULT_PERMISSIONS.user,
    lastLogin: '2023-12-20T10:30:00Z',
    createdAt: '2023-04-10T13:00:00Z',
  },
  {
    id: '7',
    firstName: 'James',
    lastName: 'Taylor',
    email: 'james.taylor@company.com',
    role: 'user',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
    companies: ['2', '4'],
    companyCount: 2,
    permissions: DEFAULT_PERMISSIONS.user,
    lastLogin: '2024-01-15T07:30:00Z',
    createdAt: '2023-08-15T10:00:00Z',
  },
  {
    id: '8',
    firstName: 'Maria',
    lastName: 'Garcia',
    email: 'maria.garcia@company.com',
    phone: '+44 117 929 0006',
    role: 'user',
    status: 'active',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
    companies: ['1', '5'],
    companyCount: 2,
    permissions: DEFAULT_PERMISSIONS.user,
    lastLogin: '2024-01-15T11:00:00Z',
    createdAt: '2023-06-01T09:30:00Z',
  },
];

export const mockCompanies = [
  { id: '1', name: 'Acme Corporation' },
  { id: '2', name: 'TechStart Inc.' },
  { id: '3', name: 'Global Solutions Ltd.' },
  { id: '4', name: 'Innovation Partners' },
  { id: '5', name: 'Enterprise Systems' },
];
